import { useLocation } from 'react-router-dom'
import { faCheck } from '@fortawesome/pro-regular-svg-icons'
import { faCircle } from '@fortawesome/pro-solid-svg-icons'
import { EMPLOYEE_ENROLL_PATHS, useOnboardingSteps } from '../helpers'
import { Text, Icon } from '@/ui'
import { TextColors, TypographyStyles } from '@/styles'

export const PayrollSetupList = ({ isIntro }: { isIntro?: boolean }) => {
  const steps = useOnboardingSteps()
  const location = useLocation()

  if (!steps.length) {
    return null
  }

  return (
    <div className={`payroll-setup-list ${isIntro ? 'intro' : ''}`}>
      {steps.map((step) => {
        const { key, paths, complete, text } = step

        const isActive = paths.includes(location.pathname)

        return (
          <div
            key={key}
            className={`item flex items-center mt-2 ${isActive ? 'current' : ''}`}
          >
            {!complete && (
              <Icon
                icon={faCircle}
                size="1x"
                backgroundColor="emphasis"
                backgroundStyle="circle"
                color="text-moss-0"
              />
            )}
            {complete && (
              <Icon
                icon={faCheck}
                size="1x"
                backgroundColor="emphasis"
                backgroundStyle="circle"
              />
            )}

            <div>
              <Text
                variant={TypographyStyles.BODY_MD}
                color={isActive ? TextColors.GREEN : TextColors.DEFAULT}
              >
                {text}
              </Text>
              {key === 'employee' && isActive && (
                <ul>
                  {[
                    'Set up personal details',
                    'Add job details',
                    'Add federal tax info',
                    'Add state tax info',
                    'Add payment info',
                  ].map((text, index) => {
                    const isSubItemActive =
                      index === EMPLOYEE_ENROLL_PATHS.indexOf(location.pathname)
                    return (
                      <li
                        key={text}
                        className={`item sub-item ${
                          isSubItemActive ? 'current' : ''
                        }`}
                      >
                        <Text
                          variant={TypographyStyles.BODY_MD}
                          color={
                            isSubItemActive
                              ? TextColors.BRAND
                              : TextColors.DEFAULT
                          }
                        >
                          &bull; {text}
                        </Text>
                      </li>
                    )
                  })}
                </ul>
              )}
            </div>
          </div>
        )
      })}
    </div>
  )
}
